<template>
  <vs-table
    :multiple="multiple"
    no-data-text="No tienes carga de combustible"
    v-model="loadsGasolineSelected"
    :data="loadsGasoline"
    class="table"
  >
    <template slot="thead">
      <vs-th >Litros</vs-th>
      <vs-th>Vale/Factura</vs-th>
      <vs-th>Monto</vs-th>
      <vs-th>Km Carga</vs-th>
      <vs-th>Voucher</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
        <vs-td :data="data[indextr].liters">
          {{tr.liters}}
        </vs-td>
        <vs-td :data="data[indextr].invoice">
          {{tr.invoice}}
        </vs-td>
        <vs-td :data="data[indextr].amount">
          {{tr.amount | amount}}
        </vs-td>
        <vs-td :data="data[indextr].kilometerCharge">
          {{tr.kilometerCharge}}
        </vs-td>
        <vs-td :data="data[indextr].voucher">
          <DownloadFile
            :name="tr.voucher.name"
            :path="tr.voucher.path"
            class="pill-info-attach"
            v-b-tooltip="'Descargar'"
          >
          </DownloadFile>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
<script>
import DownloadFile from '@/febos/chile/dnt/components/DownloadFile';

export default {
  components: {
    DownloadFile
  },
  data() {
    return {
      loadsGasolineSelected: this.value || []
    };
  },
  watch: {
    loadsGasolineSelected() {
      this.$emit('input', this.loadsGasolineSelected);
    },
    value(newValue) {
      this.loadsGasolineSelected = newValue;
    }
  },
  props: {
    loadsGasoline: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>
